import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SurveyComment } from '@ps/survey-utils';

import { SurveyCommentsApi } from '../../api/survey-comments/survey-comments.api';

@Injectable({ providedIn: 'root' })
export class SurveyCommentsService {
  private readonly _api = inject(SurveyCommentsApi);

  public commentsForSurvey(surveyId: number): Observable<SurveyComment[]> {
    return this._api.commentsForSurvey(surveyId);
  }
}
